import React from "react";
import { Helmet } from "react-helmet";

function PrivacyPolicy() {
  document.title = "Privacy Policy » ClubHosty";
  return (
    <>
      <Helmet>
        <title>Privacy Policy » ClubHosty</title>
        <link rel="canonical" href="https://www.clubhosty.com/privacypolicy" />
      </Helmet>
      <main id="main">
        <section className="breadcrumbs">
          <div className="container">
            <div>
              <h2>Privacy Policy</h2>
              <br />
              <center>
                <p>
                  Privacy is a very important point and we respect privacy. Your
                  privacy is important for us below you can read what
                  information we collect from you. And what we do with that
                  information, don’t worry we keep the user information low.
                </p>
              </center>
            </div>
          </div>
        </section>

        {/* ======= Services Section =======  */}
        <section id="services" className="services">
          <div className="container">
            <div className="row">
              <div className="col-md-12 ">
                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    The Information We Collect :
                  </h3>
                  <p className="m-15px-b">
                    When you sign up with Clubhosty it means you agree with our
                    terms and conditions, we will take your information like
                    name, home address, phone number, e-mail addresses and
                    payment details (credit or debit card and PayPal).
                  </p>
                  <p className="m-15px-b">
                    When you contact our dedicated support team, they’ll require
                    your information. Actually Clubhosty collects personally
                    identifiable information from Users through online forms for
                    ordering products and services.
                  </p>
                  <p className="m-15px-b">
                    We may also collect information about how Users use our
                    Website, for example, by tracking the number of unique views
                    received by the pages of the Web site or the domains from
                    which Users originate. We use "cookies" to track how Users
                    use our Website.
                  </p>
                </div>
                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    How We Use Information :
                  </h3>
                  <p className="m-15px-b">
                    ClubHosty may use personally identifiable information
                    collected through our Web site to contact Users regarding
                    products and services offered by ClubHosty and its trusted
                    affiliates, independent contractors and business partners,
                    and otherwise to enhance Users' experience with ClubHosty
                    and such affiliates, independent contractors and business
                    partners.
                  </p>
                  <p className="m-15px-b">
                    At no time will ClubHosty's database of users ever be sold
                    to any entity for the purpose of marketing or mailing lists.
                    Personal information will not be sold or otherwise
                    transferred to our business partners without your prior
                    consent, except that we will disclose the information we
                    collect to third parties when, in our good faith judgment,
                    we are obligated to do so under applicable laws.
                  </p>
                </div>
                <div className="section-heading">
                  <h3 className="black-color p-5px-b">Cookies : </h3>
                  <p className="m-15px-b">
                    A cookie is a small text file that is stored on a user's
                    computer for record-keeping purposes. We use cookies on this
                    site. We do not link the information we store in cookies to
                    any personally identifiable information you submit while on
                    our site. We use both session ID cookies and persistent
                    cookies.
                  </p>
                  <p className="m-15px-b">
                    We use session cookies to make it easier for you to navigate
                    our site. A session ID cookie expires when you close your
                    browser. A persistent cookie remains on your hard drive for
                    an extended period of time much like the cookie used for our
                    affiliate program. You can remove persistent cookies by
                    following directions provided in your Internet browsers
                    'help' file.
                  </p>
                  <p className="m-15px-b">
                    We set a persistent cookie to store your passwords, so you
                    do not have to enter them more than once. Persistent cookies
                    also enable us to track and target the interests of our
                    users to enhance the experience on our site. If you reject
                    cookies, you may still use our site, but you will be asked
                    to enter your username and password again every time you
                    close your browser or your session has timed out.
                  </p>
                </div>
                <div className="section-heading">
                  <h3 className="black-color p-5px-b">Log Files :</h3>
                  <p className="m-15px-b">
                    As is true of most Web sites, we gather certain information
                    automatically and store it in log files. This information
                    includes internet protocol (IP) addresses, browser type,
                    internet service provider (ISP), referring/exit pages,
                    operating system, date/time stamp, and clickstream data. We
                    use this information, which does not identify individual
                    users, to analyze trends, to administer the site, to track
                    users movements around the site and to gather demographic
                    information about our user base as a whole. We do not link
                    this automatically collected data to personally identifiable
                    information.
                  </p>
                  <p className="m-15px-b">
                    This might incorporate overseeing a help like an enlistment,
                    email, discussion, and so forth, or reaching you in the
                    event that you have demonstrated your authorization to do as
                    such by consenting to acknowledge the further warning and
                    administration declaration from us on your part profile
                    page. You can decide to quit from getting any further notice
                    from your part profile page. We don't impart this data to
                    outside parties.
                  </p>
                  <p className="m-15px-b">
                    IP addresses are attached to by and by recognizable data to
                    forestall and impede victimizers to continue to utilize our
                    administrations, for example, individuals who disregard our
                    terms of administration. We utilize an outsider following
                    help that utilizes treats and logs records to follow non-by
                    and by recognizable data about guests to our webpage in the
                    total of utilization and volume measurements to decide how
                    our clients explore through our site and to realize the
                    number of clients is utilizing our administrations
                    demographically. We utilize the data you give about yourself
                    or others to finish the exchange for which it is expected.
                  </p>
                </div>
                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    Interchanges From The Site :
                  </h3>
                  <p className="m-15px-b">
                    At the point when we get an email, we use return email
                    locations to answer with the data mentioned. Such locations
                    are not utilized for some other reason and are not imparted
                    to outside parties. When providing contact data to
                    ClubHosty.com you can demonstrate your inclination on the
                    off chance that you might want to be reached to get data and
                    updates about our administrations by signing in to your
                    ClubHosty.com account, going to your part profile page and
                    decide not to get any further warning messages from us or
                    other data relating to ClubHosty.com.
                  </p>
                  <p className="m-15px-b">
                    Data you submit to us won't be utilized for this reason
                    except if you demonstrate this as your inclination. When
                    providing contact data to ClubHosty.com you can demonstrate
                    your inclination on your individual’s profile page to take
                    part in the ClubHosty.com pamphlet. You will get an
                    affirmation email from us while submitting a request on our
                    site and paying through the instalment door.
                  </p>
                </div>
                <div className="section-heading">
                  <h3 className="black-color p-5px-b">Newsletter :</h3>
                  <p className="m-15px-b">
                    We give you the chance to 'pick in' and 'quit' our bulletin
                    whenever. Our bulletin is sent each month so it will
                    positively contain a ton of valuable data and any offers we
                    might have. On the off chance that you presently don't wish
                    to accept our pamphlet and special interchanges, you might
                    quit getting them whenever.
                  </p>
                </div>
                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    Data Sharing and Disclosure :
                  </h3>
                  <p className="m-15px-b">
                    We gather data from our site guests utilizing Google
                    Analytics. We utilize this data to more readily plan our
                    website and administrations. This data is never imparted to
                    any outsider. We don't connect total client information with
                    by and by recognizable data.
                  </p>
                </div>
                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    Actually Identifiable Information :
                  </h3>
                  <p className="m-15px-b">
                    ClubHosty.com doesn't share, sell, lease, or exchange
                    actually recognizable data with outsiders. We never use or
                    offer the actual recognizable data given to us online in
                    manners disconnected to the ones depicted inside this
                    security strategy without additionally giving you a chance
                    to quit or in any case restrict such random employment.
                  </p>
                </div>
                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    How You Can Access/Correct Your Information :
                  </h3>
                  <p className="black-color p-5px-b">
                    You can get all your by and by recognizable data that we
                    gather by signing into your secret word secured
                    ClubHosty.com record and choosing to refresh your 'My
                    Details' We utilize this system to more readily protect your
                    data. You can likewise address genuine blunders in your by
                    and by recognizable data by sending us a solicitation that
                    believably shows mistakes. To ensure your protection and
                    security, we will likewise find sensible ways to confirm
                    your character prior to giving access or making
                    rectifications.
                  </p>
                </div>
                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    Explicit Terms and Conditions :
                  </h3>
                  <p className="black-color p-5px-b">
                    ClubHosty.com considers email communicated by means of our
                    administration to be the private correspondence between the
                    sender and beneficiary. We won't screen, alter or reveal the
                    substance of a client's private interchanges, besides as
                    legally necessary, to follow lawful interaction, if
                    important to implement the Service Agreement, to react to
                    claims that such substance abuse the privileges of
                    outsiders, or to secure the rights or property of
                    ClubHosty.com.
                  </p>
                  <p className="black-color p-5px-b">
                    By utilizing the help you concur that specialized
                    preparation of email interchanges is and might be needed to
                    send and get messages, to adjust to the specialized
                    prerequisites of associating networks, to adjust to the
                    limits of the Service, or to adjust to other, comparative
                    specialized necessities.
                  </p>
                  <p className="black-color p-5px-b">
                    By utilizing the assistance you recognize and concur that
                    ClubHosty.com don't underwrite the substance of any client
                    interchanges and are not dependable or obligated for any
                    unlawful, bothering, hostile, security attacking,
                    oppressive, compromising, unsafe, profane, revolting,
                    convoluted, or in any case offensive substance, or content
                    that encroaches or may encroach the protected innovation or
                    different privileges of another.
                  </p>
                </div>
                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    Legitimate Disclaimer :
                  </h3>
                  <p className="black-color p-5px-b">
                    We maintain all authority to reveal your actually
                    recognizable data as legally necessary and when we accept
                    that exposure is important to ensure our privileges as well
                    as to consent to legal action, court request, or lawful
                    cycle served on our Web webpage.
                  </p>
                </div>
                <div className="section-heading">
                  <h3 className="black-color p-5px-b">Security :</h3>
                  <p className="black-color p-5px-b">
                    We maintain all authority to reveal your actually
                    recognizable data as legally necessary and when we accept
                    that exposure is important to ensure our privileges as well
                    as to consent to legal action, court request, or lawful
                    cycle served on our Web webpage.
                  </p>
                  <p className="black-color p-5px-b">
                    The security of your data is important to us. We keep
                    commonly acknowledged industry guidelines to ensure the
                    individual data is submitted to us, both during transmission
                    and when we get it. No strategy for transmission over the
                    Internet, or technique for electronic capacity, is 100%
                    secure, but we have made all steps imaginable to make your
                    data safe.
                  </p>
                  <p className="black-color p-5px-b">
                    This site is secured by Secure Socket Layer (SSL) to
                    guarantee your information is safe. Along these lines, while
                    we endeavour to utilize economically OK intends to assure
                    your own data, we can't ensure its outright security.
                  </p>
                </div>
                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    Connections To Other Sites :
                  </h3>
                  <p className="black-color p-5px-b">
                    This Web webpage contains connections to different
                    destinations that are not possessed or constrained by
                    ClubHosty.com. Kindly know that we, ClubHosty.com are not
                    answerable for the protection practices of such different
                    regions. We urge you to know when you leave our website and
                    to peruse the security articulations of every single Web
                    webpage that gathers recognizable data. This security
                    explanation applies just to data gathered by this Web
                    webpage.
                  </p>
                </div>
                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    Changes To This Privacy Statement :
                  </h3>
                  <p className="black-color p-5px-b">
                    In the event that we choose to change our security strategy,
                    we will present those progressions on this protection
                    articulation, the landing page, and different spots we
                    consider fitting so you know about what data we gather, how
                    we use it, and under what conditions, assuming any, we
                    unveil it. We maintain all authority to adjust this security
                    proclamation whenever, so kindly survey it as often as
                    possible. On the off chance that we roll out material
                    improvements to this arrangement, we will tell you here, by
                    email, or through a notification on our landing page. For
                    more data kindly don't spare a moment to send your inquiries
                    through our contact structure.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* End Services Section  */}
      </main>
      {/* End #main */}
    </>
  );
}

export default PrivacyPolicy;
